import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { verifyDcr, verifyDer } from '../api/billing.api';
import type { VerifyDcrPayload, VerifyDerPayload } from '../types/billing.types';

interface VerifyDcrArgs {
  recordId: number;
  payload: VerifyDcrPayload;
}

interface VerifyDerArgs {
  detailId: number;
  payload: VerifyDerPayload;
}

const MESSAGE = {
  verify: { success: 'Verified', failure: 'Could not verify this entry' },
  reject: { success: 'Rejected', failure: 'Could not reject this entry' },
};

export function useVerifyDcr() {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ recordId, payload }: VerifyDcrArgs) => verifyDcr(recordId, payload),
    onSuccess: (_data, { payload }) => {
      void refreshRelatedData('billingEntry');
      toast.success(payload.accept ? MESSAGE.verify.success : MESSAGE.reject.success);
    },
    onError: (error, { payload }) => {
      showApiErrorToast(error, payload.accept ? MESSAGE.verify.failure : MESSAGE.reject.failure);
    },
  });
}

export function useVerifyDer() {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ detailId, payload }: VerifyDerArgs) => verifyDer(detailId, payload),
    onSuccess: (_data, { payload }) => {
      void refreshRelatedData('billingEntry');
      toast.success(payload.accept ? MESSAGE.verify.success : MESSAGE.reject.success);
    },
    onError: (error, { payload }) => {
      showApiErrorToast(error, payload.accept ? MESSAGE.verify.failure : MESSAGE.reject.failure);
    },
  });
}
